import * as actionTypes from "./actionTypes";
import {GET_LOYALTY_INFORMATION} from "./actionTypes";
import {GET_LOYALTY_INFORMATION_SUCCEEDED} from "./actionTypes";

export const getCompanyInfo = () => {
    return {
        type: actionTypes.GET_SELECTED_COMPANY_INFO
    };
};

export const getCompanyInfoSucceeded = (companyInfo) => {
    return {
        type: actionTypes.GET_COMPANY_INFO_SUCCEEDED    ,
        companyInfo: companyInfo,
    };
};

export const getShop = (shopID) => {
    return {
        type: actionTypes.GET_SHOP,
        shopID
    }
};

export const getShopSucceeded = (shop, shopId) => {
    return {
        type: actionTypes.GET_SHOP_SUCCEEDED,
        shop: shop,
        shopId: shopId
    }
};

export const getShopFailed = () => ({
    type: actionTypes.GET_SHOP_FAILED,
});

export const getShopList = () => ({
    type: actionTypes.GET_SHOP_LIST
});

export const getShopListSucceeded = (shops) => ({
    type: actionTypes.GET_SHOP_LIST_SUCCEEDED,
    shops
});

export const getLoyaltyInformation = () => ({
    type: GET_LOYALTY_INFORMATION
});

export const getLoyaltyInformationSucceeded = (payload) => ({
    type: GET_LOYALTY_INFORMATION_SUCCEEDED,
    payload
});

export const loadShopID = () => ({
    type: actionTypes.LOAD_SHOP_ID
});

export const getGroupFilterOptions = (shopId) => ({
    type: actionTypes.GET_GROUP_FILTER_OPTIONS,
    shopId,
});

export const getGroupFilterOptionsSucceeded = (payload) => ({
    type: actionTypes.GET_GROUP_FILTER_OPTIONS_SUCCEEDED,
    payload,
});

export const setActiveFilters = (payload) => ({
    type: actionTypes.SET_ACTIVE_FILTERS,
    payload,
});

export const getPromotions = () => ({
    type: actionTypes.GET_PROMOTIONS,
});

export const setPromotions = (promotions) => ({
    type: actionTypes.SET_PROMOTIONS,
    payload: promotions,
});
